/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InvestorBankAccountSortOrder {
    ASC = 'asc',
    DESC = 'desc',
}
